import React from 'react';
import { SettingsContent } from '../../components/settings/SettingsContent';

/**
 * Settings page for the Glossary app
 * Uses the shared SettingsContent component
 */
const GlossarySettings: React.FC = () => {
  return (
    <div className="p-4 md:p-8 max-w-6xl mx-auto">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-6">Settings</h1>
      
      {/* Reusable Settings Content */}
      <SettingsContent showProfilePicture={true} />
    </div>
  );
};

export default GlossarySettings;